import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders, StaticProvider } from '@angular/core';
import { DcTenant, type DcTenantCode, getTenantFromCode } from '@rma/generic/core/instance';

export const RmaTenant = new InjectionToken<DcTenant>('RmaTenant');

export function provideRmaTenant(code: DcTenantCode): EnvironmentProviders {
  return makeEnvironmentProviders(provideRmaTenantStatic(code));
}

export function provideRmaTenantStatic(code: DcTenantCode): StaticProvider[] {
  const tenant = getTenantFromCode(code);
  return [{ provide: RmaTenant, useValue: tenant }];
}
